import { HttpContextToken } from '@angular/common/http';

/** true si esta petición ya se reintentó tras un refresh de token (evitar bucles). */
export const MB_AUTH_REFRESH_RETRY = new HttpContextToken<boolean>(() => false);

/**
 * Override de X-Rbac-Service (raro: heurística por URL basta en la mayoría de casos).
 */
export const MB_RBAC_SERVICE = new HttpContextToken<string | null>(() => null);

/**
 * Si true, Authorization/X-User-Sub pueden tomarse de sessionStorage si no hay usuario en memoria.
 */
export const MB_SESSION_TOKEN_FALLBACK = new HttpContextToken<boolean>(() => false);
